/**
 * Legacy API stubs.
 * All legacy integrations have been removed for Omni Ad.
 * These stubs exist to prevent import errors from remaining callers.
 */

import type { AuthUser } from '@/utils/auth';

export interface OmniadApiError extends Error {
  status?: number;
  code?: string;
}

// ── Auth stubs (replaced by Supabase) ────────────────────────────

export async function sendMagicLinkEmail(_params: { email: string; first_name?: string; account_type?: string }): Promise<{ code: string }> {
  throw new Error('Use Supabase auth instead');
}

export async function getCurrentUser(_token: string): Promise<AuthUser> {
  throw new Error('Use Supabase auth instead');
}

export async function updateCurrentUser(_token: string, _updates: Record<string, unknown>): Promise<AuthUser> {
  throw new Error('Use Supabase auth instead');
}

// ── Brand stubs ──────────────────────────────────────────────────

export interface TeamBrand {
  brand_id: string;
  name: string;
  logo_url?: string;
}

export async function getTeamBrands(_teamId: string, _token: string): Promise<TeamBrand[]> {
  return []; // Brands are now managed locally via the cowork API
}

// ── User settings stubs ──────────────────────────────────────────

export async function addUserEmail(_token: string, _email: string): Promise<void> {
  throw new Error('User settings not available');
}

export async function forgetUserEmail(_token: string, _emailId: string): Promise<void> {
  throw new Error('User settings not available');
}

export async function makePrimaryUserEmail(_token: string, _emailId: string): Promise<void> {
  throw new Error('User settings not available');
}

export async function verifyUserEmail(_token: string, _emailId: string): Promise<void> {
  throw new Error('User settings not available');
}

export async function verifyUserPhone(_token: string, _code: string): Promise<void> {
  throw new Error('User settings not available');
}

// ── Campaign stubs (platform features removed) ──────────────────

export interface ClientCampaign { [key: string]: unknown }
export interface ApiBeat { [key: string]: unknown }
export interface ClientCuration { [key: string]: unknown }
export interface ClientDraftVersion { [key: string]: unknown }

export async function getCampaignsSearch(): Promise<never[]> { return []; }
export async function getCampaign(): Promise<null> { return null; }
export async function getCampaignBeat(): Promise<null> { return null; }
export async function getCampaignCuration(): Promise<never[]> { return []; }
export async function getCampaignDrafts(): Promise<never[]> { return []; }
export async function acceptCuratedInfluencer(): Promise<void> {}
export async function rejectCuratedInfluencer(): Promise<void> {}
